import { useQuery } from "react-query";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { PackagingReferenceKind, PackagingReferenceUnified, PackagingReferenceUnifiedSchema } from "./types";

export const getAllPackagingReferencesUnifiedKey = "allPackagingReferencesUnified" as const;

type Options = {
    q?: string;
    kind?: PackagingReferenceKind | "all";
    page?: number;
    itemsPerPage?: number;
    enabled?: boolean;
};

export const useGetAllPackagingReferencesUnified = (options?: Options) => {
    const { q = "", kind = "all", page = 1, itemsPerPage = 50, enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getAllPackagingReferencesUnifiedKey, q, kind, page, itemsPerPage],
        enabled,
        queryFn: async () => {
            return await loggedInApiCall.get("/api/packaging-references-unified", {
                params: {
                    q: q !== "" ? q : undefined,
                    kind,
                    page,
                    itemsPerPage,
                },
            });
        },
        select: (response) => {
            const totalItems: number = response.data["hydra:totalItems"] ?? 0;
            const items = response.data["hydra:member"] ?? [];
            const data = zodParseWithLog(
                items,
                PackagingReferenceUnifiedSchema.array(),
                getAllPackagingReferencesUnifiedKey,
            );

            return {
                packagingReferences: data,
                totalItems,
            };
        },
    });

    return {
        packagingReferences: query.data?.packagingReferences as PackagingReferenceUnified[] | undefined,
        totalItems: query.data?.totalItems,
        ...query,
    };
};
